export const AnalysisLogsTable = ({ expandedLogs, userId, capitalize }) => {
  const logs = (expandedLogs[userId]?.logs || []).filter(log => {
    const action = (log.action || "").toLowerCase();
    return !action.includes("pdf download");
  });

  return (
    <tr className="logs-row">
      <td colSpan={13} className="logs-table-td">
        {logs.length === 0 ? (
          <p style={{ textAlign: "left", fontSize: "small", border: "none" }}>
            No logs available
          </p>
        ) : (
          <table className="data-table logs-table-responsive"style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>Action</th>
                <th>Source</th>
                <th>Name</th>
                <th>Email</th>
                <th>Timestamp</th>
                <th>Changes</th>
                <th>Reason</th>
              </tr>
            </thead>

            <tbody>
              {logs.map((log) => {
                return (
                  <tr key={`${log._id}`}>
                    <td data-label="Action">
                      {capitalize(log.action)}
                    </td>

                    <td data-label="Source">{log.source}</td>

                    <td data-label="By">{log.adminName || "—"}</td>

                    <td data-label="Email">{log.adminEmail || "—"}</td>

                    <td data-label="Timestamp">
                      {new Date(log.timestamp).toLocaleString(undefined, {
                        weekday: "short",
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </td>

                    <td data-label="Changes">
                      {log.oldStatus || log.newStatus ? (
                        <div>
                          <strong>Status:</strong> "{log.oldStatus || "—"}" → "{log.newStatus || "—"}"
                        </div>
                      ) : (
                        "—"
                      )}
                    </td>

                    <td data-label="Reason">
                      {log.reason ? <span style={{ textTransform: "capitalize" }}>{log.reason}</span> : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  );
};
